/* BuddyLab Theme — global.js
 * Minimal client-side interactions for the theme
 * ----------------------------------------------- */

/* #121: inertização de fundo compartilhada por dialogs modais (cart drawer,
   menu mobile). Mesmo algoritmo do drawer de filtros (#74): descemos a
   árvore a partir de <body> e só entramos nos ancestrais estritos dos
   `targets`, escondendo os irmãos encontrados pelo caminho — evita depender
   de os targets serem filhos diretos de #MainContent/<body> mesmo com o
   wrapper .shopify-section do OS 2.0 no meio. */
window.BuddyLabHideBackground = function (targets, hidden) {
  var supportsInert = 'inert' in HTMLElement.prototype;

  function strictAncestors(el) {
    var chain = [];
    el = el.parentElement;
    while (el) {
      chain.push(el);
      el = el.parentElement;
    }
    return chain;
  }

  var ancestors = targets.reduce(function (acc, t) {
    return acc.concat(strictAncestors(t));
  }, []);

  function walk(parent) {
    Array.prototype.forEach.call(parent.children, function (el) {
      if (targets.indexOf(el) !== -1) return;
      if (ancestors.indexOf(el) !== -1) {
        walk(el);
        return;
      }
      if (hidden) {
        if (supportsInert) el.inert = true;
        el.setAttribute('aria-hidden', 'true');
      } else {
        if (supportsInert) el.inert = false;
        el.removeAttribute('aria-hidden');
      }
    });
  }

  walk(document.body);
};

(function () {
  'use strict';

  // ---- PRODUCT CARD: variant swatch image swap ----
  document.querySelectorAll('[data-pcard]').forEach(function (card) {
    var imgs = card.querySelectorAll('[data-pimg]');
    var swatches = card.querySelectorAll('[data-psw]');
    var flavorLabel = card.querySelector('[data-pflavor]');
    var variantInput = card.querySelector('[data-card-variant-input]');
    var priceEl = card.querySelector('[data-card-price]');
    var installmentsEl = card.querySelector('[data-card-installments]');
    var pricePrefixEl = card.querySelector('[data-card-price-prefix]');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = sw.getAttribute('data-psw');
        swatches.forEach(function (s) {
          var isActive = s === sw;
          s.classList.toggle('active', isActive);
          s.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        var matchedImage = false;
        imgs.forEach(function (img) {
          var variantIds = img.getAttribute('data-variant-ids');
          var matches = img.getAttribute('data-pimg') === id ||
            (variantIds && variantIds.indexOf('|' + id + '|') !== -1);
          if (matches) matchedImage = true;
          if (matches) img.classList.add('show');
        });
        if (matchedImage) imgs.forEach(function (img) {
          var variantIds = img.getAttribute('data-variant-ids');
          var matches = img.getAttribute('data-pimg') === id ||
            (variantIds && variantIds.indexOf('|' + id + '|') !== -1);
          img.classList.toggle('show', !!matches);
        });
        if (flavorLabel) flavorLabel.textContent = sw.getAttribute('data-label') || '';
        // o form adiciona a variante selecionada, não sempre a primeira
        if (variantInput) variantInput.value = id;
        var price = sw.getAttribute('data-price');
        if (price) {
          if (priceEl) priceEl.textContent = price;
          var btnPrice = card.querySelector('[data-card-add-price]');
          if (btnPrice) btnPrice.textContent = price;
          // Com uma variante escolhida à mão o preço deixou de ser "a partir de".
          if (pricePrefixEl) pricePrefixEl.hidden = true;
        }
        var installments = sw.getAttribute('data-installments');
        if (installmentsEl && installments) installmentsEl.innerHTML = installments;
        card.dispatchEvent(new CustomEvent('pcard:variant', { detail: { id: id } }));
      });
    });
  });

  // ---- HERO: flavor swatch swap ----
  document.querySelectorAll('[data-hero-swatch]').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var stage = sw.closest('.hero').querySelector('.hero-stage');
      if (!stage) return;
      var id = sw.getAttribute('data-hero-swatch');
      stage.querySelectorAll('img').forEach(function (img) {
        img.style.opacity = img.getAttribute('data-img') === id ? '1' : '0';
      });
      sw.parentElement.querySelectorAll('[data-hero-swatch]').forEach(function (s) {
        var isActive = s === sw;
        s.classList.toggle('active', isActive);
        s.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      var badge = stage.querySelector('.hero-badge');
      if (badge) badge.textContent = sw.getAttribute('data-label');
    });
  });

  // ---- ROTAS DO CARRINHO ----
  // A raia D publica routes.* como data-* no <body>. Fallback para as rotas padrão
  // caso o atributo ainda não exista (ordem de merge das raias).
  function themeRoute(attr, fallback) {
    var value = document.body ? document.body.getAttribute(attr) : null;
    return value && value.length ? value : fallback;
  }
  var CART_ADD_URL = themeRoute('data-cart-add-url', '/cart/add.js');
  var CART_JSON_URL = themeRoute('data-cart-url', '/cart').replace(/\.js$/, '') + '.js';

  // ---- STRINGS DE INTERFACE ----
  // O layout publica os textos traduzidos (| t) como data-label-* no <body>.
  // Nada de string fixa aqui: em EN o JS precisa falar EN.
  function themeLabel(attr) {
    var value = document.body ? document.body.getAttribute(attr) : null;
    return value && value.length ? value : '';
  }

  // Último recurso: o Shopify já devolve `description` traduzido nos erros 422,
  // e a PDP tem sua própria mensagem via locale em [data-cart-error].
  var GENERIC_ADD_ERROR = themeLabel('data-label-add-error');

  // #96: aria-label fixo no link da sacola escondia a contagem do leitor de
  // tela. O nome acessível agora vem de um <span class="visually-hidden"> no
  // próprio link (sections/header.liquid), e esta função mantém seu texto em
  // sincronia com o badge visual — os rótulos traduzidos vêm de data-label-*
  // no <body> (layout/theme.liquid) pra não hard-codar string em JS.
  function cartCountLabel(count) {
    var base = document.body.getAttribute('data-label-cart') || '';
    if (!count) return base;
    var tmpl = document.body.getAttribute(count === 1 ? 'data-label-cart-item-one' : 'data-label-cart-item-other') || '';
    return tmpl ? base + ', ' + tmpl.replace('__N__', count) : base;
  }

  // ---- CART: refresh badge after AJAX add ----
  // Devolve o carrinho e avisa o resto do tema (drawer, barra mobile) via evento.
  function refreshCartBadge() {
    return fetch(CART_JSON_URL)
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
        document.querySelectorAll('[data-cart-count-label]').forEach(function (el) {
          el.textContent = cartCountLabel(cart.item_count);
        });
        document.dispatchEvent(new CustomEvent('buddylab:cart:updated', { detail: cart }));
        return cart;
      }).catch(function () {});
  }

  // ---- MONEY: formatador a partir de shop.money_format ----
  function formatMoney(cents, format) {
    format = format || 'R$ {{amount_with_comma_separator}}';
    function num(decimalSep, thousandSep, decimals) {
      var value = (Math.round(cents) / 100).toFixed(decimals);
      var parts = value.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
      return parts[1] ? whole + decimalSep + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount': return num('.', ',', 2);
        case 'amount_no_decimals': return num('.', ',', 0);
        case 'amount_with_comma_separator': return num(',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return num(',', '.', 0);
        case 'amount_with_apostrophe_separator': return num('.', "'", 2);
        default: return '';
      }
    });
  }

  // ---- ADD TO CART (AJAX) — cards e PDP ----
  function cartErrorBox(form) { return form.querySelector('[data-cart-error]'); }

  function showFormError(form, message, fallbackEl, fallbackHtml) {
    var box = cartErrorBox(form);
    if (box) {
      box.textContent = message || box.getAttribute('data-default-text') || GENERIC_ADD_ERROR;
      box.hidden = false;
      return;
    }
    // Formulários sem caixa de erro (cards): degrada para o rótulo do botão.
    if (!fallbackEl) return;
    fallbackEl.textContent = message || GENERIC_ADD_ERROR;
    setTimeout(function () { fallbackEl.innerHTML = fallbackHtml; }, 2500);
  }

  function clearFormError(form) {
    var box = cartErrorBox(form);
    if (!box) return;
    box.hidden = true;
    box.textContent = '';
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
    // "Comprar agora" e afins submetem nativamente (checkout direto).
    var skipAjax = false;
    form.querySelectorAll('[data-skip-ajax]').forEach(function (el) {
      el.addEventListener('click', function () { skipAjax = true; });
    });

    form.addEventListener('submit', function (e) {
      if (skipAjax) { skipAjax = false; return; }
      e.preventDefault();

      var btn = form.querySelector('[data-add-btn]') || form.querySelector('button[type="submit"]');
      if (btn && btn.disabled) return;
      var label = (btn && btn.querySelector('[data-add-label]')) || btn;
      var origHtml = label ? label.innerHTML : '';
      var textAdding = (btn && btn.getAttribute('data-label-adding')) || themeLabel('data-label-adding');
      var textAdded = (btn && btn.getAttribute('data-label-added')) || themeLabel('data-label-added');

      clearFormError(form);
      if (label) label.textContent = textAdding;
      if (btn) btn.disabled = true;

      fetch(CART_ADD_URL, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json()
            .catch(function () { return {}; })
            .then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (btn) btn.disabled = false;
          if (!res.ok) {
            if (label) label.innerHTML = origHtml;
            showFormError(form, res.data.description || res.data.message, label, origHtml);
            return;
          }
          if (label) label.textContent = textAdded;
          if (btn) btn.classList.add('is-added');
          refreshCartBadge();
          document.dispatchEvent(new CustomEvent('buddylab:cart:added'));
          setTimeout(function () {
            if (label) label.innerHTML = origHtml;
            if (btn) btn.classList.remove('is-added');
          }, 1600);
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          if (label) label.innerHTML = origHtml;
          showFormError(form, null, label, origHtml);
        });
    });
  });

  // ---- PDP: seleção de variante pela COMBINAÇÃO de opções ----
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var dataEl = root.querySelector('[data-pdp-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!variants || !variants.length) return;

    var moneyFormat = root.getAttribute('data-money-format');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-variant-chip]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var stageImgs = Array.prototype.slice.call(root.querySelectorAll('[data-gal-img]'));
    var idInput = root.querySelector('[data-variant-id-input]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var compareEl = root.querySelector('[data-pdp-compare]');
    var saveEl = root.querySelector('[data-pdp-save]');
    var galBadgeSaleEl = root.querySelector('[data-gal-badge-sale]');
    var installEl = root.querySelector('[data-pdp-install]');
    var pixEl = root.querySelector('[data-pdp-pix]');
    var mainImg = root.querySelector('[data-pdp-main-img]');
    var addBtn = root.querySelector('[data-add-btn]');
    var addLabel = addBtn && addBtn.querySelector('[data-add-label]');
    var addPrice = root.querySelector('[data-add-price]');
    var buyNowBtn = root.querySelector('[data-buy-now]');
    var qtyInput = root.querySelector('[data-qty] input');
    var taglineEl = root.querySelector('[data-pdp-tagline]');
    var ingredientsEl = root.querySelector('[data-pdp-ingredients]');
    var ingredientsContentEl = root.querySelector('[data-pdp-ingredients-content]');
    var detailsId = root.getAttribute('data-pdp-details-id');
    var detailsSection = detailsId && document.querySelector('[data-pdp-details="' + detailsId + '"]');
    var nutritionEl = detailsSection && detailsSection.querySelector('[data-pdp-nutrition]');
    var portionEl = detailsSection && detailsSection.querySelector('[data-pdp-nutrition-portion]');
    var qtyMaxMsg = root.querySelector('[data-qty-max-msg]');

    // Bolinhas de cor dos chips (metafield custom.swatch) — sem style inline no markup.
    root.querySelectorAll('[data-swatch]').forEach(function (dot) {
      var color = dot.getAttribute('data-swatch');
      if (color) dot.style.backgroundColor = color;
    });

    var current = null;
    if (idInput) {
      current = variants.filter(function (x) { return String(x.id) === String(idInput.value); })[0];
    }
    if (!current) current = variants.filter(function (x) { return x.available; })[0] || variants[0];
    var selected = current.options.slice();
    chips.forEach(function (chip) {
      if (!chip.classList.contains('active')) return;
      var pos = parseInt(chip.getAttribute('data-option-position'), 10) - 1;
      if (pos >= 0) selected[pos] = chip.getAttribute('data-option-value');
    });

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (variants[i].options[j] !== options[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function valueAvailable(pos, value) {
      var probe = selected.slice();
      probe[pos] = value;
      var variant = findVariant(probe);
      if (variant) return variant.available;
      // Combinação inexistente: o valor ainda vale se alguma variante dele estiver disponível.
      return variants.some(function (x) { return x.options[pos] === value && x.available; });
    }

    var galleryPos = 0;
    function showImage(index) {
      var total = stageImgs.length || thumbs.length;
      if (!total) return;
      galleryPos = ((index % total) + total) % total;
      thumbs.forEach(function (t, k) {
        var active = k === galleryPos;
        t.classList.toggle('active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      stageImgs.forEach(function (img, k) {
        var active = k === galleryPos;
        img.classList.toggle('show', active);
        if (active) img.removeAttribute('aria-hidden');
        else img.setAttribute('aria-hidden', 'true');
      });
      if (mainImg && thumbs[galleryPos]) mainImg.src = thumbs[galleryPos].getAttribute('data-img');
      fitStage(stageImgs[galleryPos]);
    }

    /* A moldura acompanha a proporção da foto em cartaz — mesma conta que o
       main-product.liquid faz na renderização, repetida aqui porque as fotos
       de um mesmo produto nem sempre têm a mesma proporção. Sem isso, trocar
       de foto reabriria a faixa vazia dos lados. */
    var stageEl = root.querySelector('[data-gal-stage]');
    function fitStage(img) {
      if (!stageEl || !img) return;
      var w = parseFloat(img.getAttribute('width'));
      var h = parseFloat(img.getAttribute('height'));
      if (!(w > 0) || !(h > 0)) return;
      stageEl.style.setProperty('--stage-ar', String(Math.min(1.25, Math.max(0.64, w / h))));
    }

    thumbs.forEach(function (thumb, k) {
      thumb.addEventListener('click', function () { showImage(k); });
    });

    var prevBtn = root.querySelector('[data-gal-prev]');
    var nextBtn = root.querySelector('[data-gal-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { showImage(galleryPos - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showImage(galleryPos + 1); });

    var favBtn = root.querySelector('[data-gal-fav]');
    if (favBtn) {
      var favId = favBtn.getAttribute('data-product-id');
      var FAV_KEY = 'buddylab-wishlist';

      function readWishlist() {
        try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); }
        catch (e) { return []; }
      }

      function paintFav(on) {
        favBtn.classList.toggle('on', on);
        favBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }

      if (favId) paintFav(readWishlist().indexOf(favId) !== -1);

      favBtn.addEventListener('click', function () {
        if (!favId) return;
        var list = readWishlist();
        var idx = list.indexOf(favId);
        var on;
        if (idx === -1) { list.push(favId); on = true; }
        else { list.splice(idx, 1); on = false; }
        try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
        paintFav(on);
      });
    }

    function updatePriceTag(variant) {
      if (!addPrice) return;
      var target = variant || findVariant(selected);
      if (!target) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      addPrice.textContent = '· ' + formatMoney(target.price_amount * qty, moneyFormat);
    }
    root.addEventListener('pdp:qtychange', function () { updatePriceTag(null); });

    function updateVariantDetails(variant) {
      if (!variant) return;

      if (taglineEl) {
        taglineEl.textContent = variant.tagline || '';
        taglineEl.hidden = !variant.tagline;
      }

      if (ingredientsEl && ingredientsContentEl) {
        ingredientsContentEl.textContent = '';
        String(variant.ingredients || '').split('\n').forEach(function (line, index) {
          if (index) ingredientsContentEl.appendChild(document.createElement('br'));
          ingredientsContentEl.appendChild(document.createTextNode(line));
        });
        ingredientsEl.hidden = !variant.ingredients;
      }

      var nutrition = Array.isArray(variant.nutrition) ? variant.nutrition : [];
      if (detailsSection) {
        var insideGrid = detailsSection.querySelector('.inside-grid');
        if (insideGrid) insideGrid.classList.toggle('no-nutri', nutrition.length === 0);
      }
      if (!nutritionEl) return;

      nutritionEl.querySelectorAll('[data-pdp-nutrition-row]').forEach(function (row) { row.remove(); });
      nutrition.forEach(function (item) {
        if (!item || typeof item !== 'object') return;
        var row = document.createElement('div');
        row.className = 'nutri-row' + (item.destaque ? ' lead' : '');
        row.setAttribute('data-pdp-nutrition-row', '');
        var label = document.createElement('span');
        label.className = 'nl';
        if (item.destaque) {
          var strong = document.createElement('b');
          strong.textContent = item.label || '';
          label.appendChild(strong);
        } else {
          label.textContent = item.label || '';
        }
        var value = document.createElement('span');
        value.className = 'nv';
        value.textContent = item.valor || '';
        row.appendChild(label);
        row.appendChild(value);
        nutritionEl.appendChild(row);
      });
      nutritionEl.hidden = nutrition.length === 0;

      if (portionEl) {
        var portion = variant.nutrition_portion || '';
        var template = portionEl.getAttribute('data-portion-template') || '__PORTION__';
        portionEl.textContent = template.replace('__PORTION__', portion);
        portionEl.hidden = !portion;
      }
    }

    function update() {
      var variant = findVariant(selected);

      chips.forEach(function (chip) {
        var pos = parseInt(chip.getAttribute('data-option-position'), 10) - 1;
        if (pos < 0) return;
        var value = chip.getAttribute('data-option-value');
        var isActive = selected[pos] === value;
        chip.classList.toggle('active', isActive);
        chip.classList.toggle('is-unavailable', !valueAvailable(pos, value));
        chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      root.querySelectorAll('[data-option-selected]').forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-option-selected'), 10) - 1;
        if (pos >= 0) el.textContent = selected[pos] || '';
      });

      if (idInput) idInput.value = variant ? variant.id : '';

      /* #  O card "Compra e volume" (blocks/_subscription.liquid) tem form
         próprio e não enxerga o seletor de variantes desta seção. Sem este
         aviso, quem escolhe um sabor na PDP acabaria comprando o primeiro. */
      if (variant) {
        document.dispatchEvent(new CustomEvent('buddylab:pdp:variant', {
          detail: { id: variant.id, price: variant.price, price_amount: variant.price_amount, available: !!variant.available }
        }));
      }
      if (priceEl && variant) {
        priceEl.textContent = variant.price;
        priceEl.classList.toggle('is-sale', !!variant.compare_at);
      }
      if (compareEl) {
        if (variant && variant.compare_at) { compareEl.textContent = variant.compare_at; compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (saveEl) {
        if (variant && variant.save) { saveEl.textContent = variant.save; saveEl.hidden = false; }
        else saveEl.hidden = true;
      }
      if (galBadgeSaleEl) {
        if (variant && variant.compare_at) { galBadgeSaleEl.textContent = '−' + variant.save_pct + '%'; galBadgeSaleEl.hidden = false; }
        else galBadgeSaleEl.hidden = true;
      }
      if (installEl && variant && variant.installments_html) installEl.innerHTML = variant.installments_html;
      if (pixEl && variant && variant.pix_html) pixEl.innerHTML = variant.pix_html;
      updatePriceTag(variant);
      updateVariantDetails(variant);

      if (variant) {
        if (variant.image_index >= 0) showImage(variant.image_index);
        else if (variant.image && mainImg) mainImg.src = variant.image;
      }

      if (addBtn || buyNowBtn) {
        var buyable = !!(variant && variant.available);
        if (buyNowBtn) buyNowBtn.disabled = !buyable;
        if (addBtn) addBtn.disabled = !buyable;
        /* O card de compra (blocks/_subscription.liquid) guarda os dois rótulos
           no DOM e alterna pelo atributo hidden, porque o rótulo disponível
           carrega o preço e precisa ser remontado a cada variante. Escrever
           textContent aqui achatava esses spans num texto só: como textContent
           ignora hidden, o botão virava "Adicionar à sacola · R$ 69,90
           Esgotado" — e, sem os spans, nunca mais voltava ao normal. Esse card
           se sincroniza sozinho no evento buddylab:pdp:variant; aqui basta o
           disabled acima. O rótulo simples (sem spans) segue tratado. */
        if (addBtn && addLabel && !addLabel.querySelector('[data-cta-available]')) {
          addLabel.textContent = buyable
            ? (addBtn.getAttribute('data-label-default') || addLabel.textContent)
            : (addBtn.getAttribute('data-label-sold-out') || themeLabel('data-label-sold-out'));
        }
      }

      if (qtyInput) {
        var max = variant && variant.max_quantity;
        if (max > 0) {
          qtyInput.setAttribute('max', max);
          if (parseInt(qtyInput.value, 10) > max) {
            qtyInput.value = max;
            // Teto mudou de variante: a mensagem tem que falar do estoque
            // desta variante, não repetir o número da anterior.
            if (qtyMaxMsg) {
              qtyMaxMsg.textContent = themeLabel('data-label-max-stock').split('__N__').join(max);
              qtyMaxMsg.hidden = false;
            }
          } else if (qtyMaxMsg) {
            qtyMaxMsg.hidden = true;
          }
        } else {
          qtyInput.removeAttribute('max');
          if (qtyMaxMsg) qtyMaxMsg.hidden = true;
        }
      }

      if (variant && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      var form = root.querySelector('[data-add-to-cart]');
      if (form) clearFormError(form);
      root.dispatchEvent(new CustomEvent('pdp:variantchange', { detail: { variant: variant } }));
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var pos = parseInt(chip.getAttribute('data-option-position'), 10) - 1;
        if (pos < 0) return;
        selected[pos] = chip.getAttribute('data-option-value');
        update();
      });
    });

    root.pdpFormatMoney = function (cents) { return formatMoney(cents, moneyFormat); };
    root.pdpCurrentVariant = function () { return findVariant(selected); };
    update();
  });

  // ---- PDP: quantity stepper ----
  // O carrinho ([data-cart-qty]) tem stepper próprio com AJAX — ver bloco #5 no fim do arquivo.
  document.querySelectorAll('[data-qty]:not([data-cart-qty])').forEach(function (box) {
    var input = box.querySelector('input');
    if (!input) return;
    var dec = box.querySelector('[data-qty-dec]');
    var inc = box.querySelector('[data-qty-inc]');
    var maxMsgScope = box.closest('form') || box.parentElement;
    var maxMsg = maxMsgScope ? maxMsgScope.querySelector('[data-qty-max-msg]') : null;

    function showMaxMsg(max) {
      if (!maxMsg) return;
      maxMsg.textContent = themeLabel('data-label-max-stock').split('__N__').join(max);
      maxMsg.hidden = false;
    }

    function hideMaxMsg() {
      if (!maxMsg) return;
      maxMsg.hidden = true;
    }

    function clamp(value) {
      var min = parseInt(input.getAttribute('min'), 10);
      var max = parseInt(input.getAttribute('max'), 10);
      if (isNaN(min) || min < 1) min = 1;
      if (isNaN(value)) value = min;
      if (value < min) value = min;
      if (!isNaN(max) && max > 0 && value > max) {
        value = max;
        showMaxMsg(max);
      } else {
        hideMaxMsg();
      }
      return value;
    }

    function apply(value) {
      input.value = clamp(value);
      box.dispatchEvent(new CustomEvent('pdp:qtychange', { bubbles: true }));
    }

    if (dec) dec.addEventListener('click', function () { apply(parseInt(input.value, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { apply(parseInt(input.value, 10) + 1); });
    input.addEventListener('change', function () { apply(parseInt(input.value, 10)); });
  });

  // ---- PDP: accordion (Descrição / Ingredientes / Envio) ----
  document.querySelectorAll('[data-acc]').forEach(function (acc) {
    acc.querySelectorAll('[data-acc-head]').forEach(function (head) {
      var item = head.closest('[data-acc-item]');
      if (!item) return;
      head.addEventListener('click', function () {
        var open = !item.classList.contains('open');
        item.classList.toggle('open', open);
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });

  // ---- PDP: barras de distribuição das avaliações ----
  document.querySelectorAll('[data-bar-fill]').forEach(function (fill) {
    var pct = parseFloat(fill.getAttribute('data-bar-fill'));
    if (isNaN(pct)) pct = 0;
    fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
  });

  refreshCartBadge();

  /* ===== #3: Card de produto — add to cart com estados de sucesso e erro ===== */
  /* Os cards usam [data-card-add] (e não [data-add-to-cart], que segue na PDP)
     para que só este handler cuide deles. */
  /* Delegado no document: sections podem substituir os cards sem executar este
     arquivo de novo. O listener continua interceptando o submit antes do
     fallback de navegação nativo. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-card-add]')) return;

    var btn = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-card-add-label]') || btn;
    if (!btn || !label) return;
    e.preventDefault();

    var original = form.getAttribute('data-label-idle') || label.textContent;

    function reset() {
      btn.classList.remove('is-added', 'is-error');
      btn.disabled = false;
      label.textContent = original;
    }

    function state(cls, text, hold) {
      clearTimeout(btn._buddyLabCardAddTimer);
      btn.classList.remove('is-added', 'is-error');
      if (cls) btn.classList.add(cls);
      label.textContent = text;
      if (hold) btn._buddyLabCardAddTimer = setTimeout(reset, hold);
    }

    clearTimeout(btn._buddyLabCardAddTimer);
    btn.disabled = true;
    label.textContent = form.getAttribute('data-label-adding') || original;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.disabled = false;
        state('is-added', form.getAttribute('data-label-added') || '✓', 700);
        refreshCartBadge();
        document.dispatchEvent(new CustomEvent('buddylab:cart:added'));
      })
      .catch(function () {
        btn.disabled = false;
        state('is-error', form.getAttribute('data-label-error') || '!', 2500);
      });
  });

  /* ===== #12: Catálogo — mini-carrossel do card rico ===== */
  document.querySelectorAll('[data-pcarousel]').forEach(function (media) {
    var card = media.closest('[data-pcard]');
    var imgs = media.querySelectorAll('[data-pimg]');
    var dots = media.querySelectorAll('[data-pdot]');
    if (imgs.length < 2) return;
    var pos = 0;
    imgs.forEach(function (img, i) { if (img.classList.contains('show')) pos = i; });

    function paint(i) {
      pos = i;
      imgs.forEach(function (img, n) { img.classList.toggle('show', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('active', n === i); });
    }

    function select(i) {
      i = (i + imgs.length) % imgs.length;

      // Imagens de variante precisam levar junto todo o estado do card
      // (swatch/label, preço, disponibilidade e id enviado ao carrinho).
      // Pintamos a mídia pedida por último porque uma variante pode ter mais
      // de uma imagem e o evento do swatch posiciona o carrossel na primeira.
      if (card) {
        var variantIds = imgs[i].getAttribute('data-variant-ids') || '';
        var swatches = card.querySelectorAll('[data-psw]');
        for (var n = 0; n < swatches.length; n++) {
          var id = swatches[n].getAttribute('data-psw');
          if (variantIds.indexOf('|' + id + '|') !== -1) {
            swatches[n].click();
            break;
          }
        }
      }
      // Mídias genéricas do produto só mudam a imagem, não a variante atual.
      paint(i);
    }

    var prev = media.querySelector('[data-pprev]');
    var next = media.querySelector('[data-pnext]');
    if (prev) prev.addEventListener('click', function () { select(pos - 1); });
    if (next) next.addEventListener('click', function () { select(pos + 1); });
    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () { select(n); });
    });

    if (card) {
      card.addEventListener('pcard:variant', function (e) {
        for (var n = 0; n < imgs.length; n++) {
          var variantIds = imgs[n].getAttribute('data-variant-ids') || '';
          if (imgs[n].getAttribute('data-pimg') === e.detail.id ||
              variantIds.indexOf('|' + e.detail.id + '|') !== -1) { paint(n); return; }
        }
      });
    }
  });

  /* ===== #12: Catálogo — densidade do grid (2/3 colunas) ===== */
  (function () {
    var grid = document.querySelector('[data-product-grid]');
    var buttons = document.querySelectorAll('[data-density]');
    if (!grid || !buttons.length) return;
    var KEY = 'buddylab-density';

    function apply(value) {
      grid.classList.remove('d-comfortable', 'd-padrao');
      grid.classList.add('d-' + value);
      buttons.forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-density') === value);
      });
    }

    var saved;
    try { saved = localStorage.getItem(KEY); } catch (e) { saved = null; }
    if (saved === 'comfortable' || saved === 'padrao') apply(saved);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-density');
        apply(value);
        try { localStorage.setItem(KEY, value); } catch (e) {}
      });
    });
  })();

  /* ===== #12: Catálogo — ordenação submete sozinha quando há JS ===== */
  document.querySelectorAll('[data-sort-form]').forEach(function (form) {
    var select = form.querySelector('[data-sort-select]');
    var go = form.querySelector('[data-sort-go]');
    if (!select) return;
    if (go) go.hidden = true;
    select.addEventListener('change', function () { form.submit(); });
  });

  /* ===== #12: Catálogo — drawer de filtros no mobile ===== */
  (function () {
    var drawer = document.querySelector('[data-filter-drawer]');
    var overlay = document.querySelector('[data-filter-overlay]');
    if (!drawer) return;
    var opener = document.querySelector('[data-filter-open]');
    var lastFocus = null;
    var supportsInert = 'inert' in HTMLElement.prototype;

    var backgroundTargets = overlay ? [drawer, overlay] : [drawer];

    function strictAncestors(el) {
      var chain = [];
      el = el.parentElement;
      while (el) {
        chain.push(el);
        el = el.parentElement;
      }
      return chain;
    }

    /* #74: o drawer é um dialog modal — o resto da página precisa sair da
       árvore de acessibilidade enquanto ele estiver aberto, senão o leitor
       de tela continua lendo por baixo do overlay. O Shopify OS 2.0 envolve
       cada seção num <div class="shopify-section">, então não dá pra supor
       que o drawer/overlay são filhos diretos de #MainContent ou <body>:
       aqui descemos a árvore a partir de <body> e só entramos nos ancestrais
       estritos do drawer/overlay, escondendo os irmãos que encontrarmos pelo
       caminho. O próprio drawer/overlay é ignorado (não some, não recursa —
       esconder os filhos dele seria inertizar o conteúdo do dialog). */
    function setBackgroundHidden(hidden) {
      var ancestors = backgroundTargets.reduce(function (acc, t) {
        return acc.concat(strictAncestors(t));
      }, []);
      function walk(parent) {
        Array.prototype.forEach.call(parent.children, function (el) {
          if (backgroundTargets.indexOf(el) !== -1) return;
          if (ancestors.indexOf(el) !== -1) {
            walk(el);
            return;
          }
          if (hidden) {
            if (supportsInert) el.inert = true;
            el.setAttribute('aria-hidden', 'true');
          } else {
            if (supportsInert) el.inert = false;
            el.removeAttribute('aria-hidden');
          }
        });
      }
      walk(document.body);
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('open');
      document.body.classList.add('no-scroll');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      setBackgroundHidden(true);
      var focusable = drawer.querySelector('[data-filter-close]');
      if (focusable) focusable.focus();
    }

    function close() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('open');
      document.body.classList.remove('no-scroll');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      setBackgroundHidden(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (opener) opener.addEventListener('click', open);
    if (overlay) overlay.addEventListener('click', close);
    drawer.querySelectorAll('[data-filter-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
  })();
})();

/* ===== #71: card — disponibilidade da variante selecionada ===== */
(function () {
  'use strict';

  document.querySelectorAll('[data-pcard]').forEach(function (card) {
    var form = card.querySelector('[data-card-add]');
    if (!form) return;

    var btn = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-card-add-label]') || btn;
    if (!btn || !label) return;

    function syncAvailability(sw) {
      if (!sw) return;
      var available = sw.getAttribute('data-available') !== 'false';
      form.setAttribute('data-variant-available', available ? 'true' : 'false');
      btn.disabled = !available;
      btn.setAttribute('aria-disabled', available ? 'false' : 'true');
      label.textContent = available
        ? (form.getAttribute('data-label-idle') || label.textContent)
        : (form.getAttribute('data-label-sold-out') || form.getAttribute('data-label-error'));
    }

    card.addEventListener('pcard:variant', function (e) {
      var id = e.detail && e.detail.id;
      if (!id) return;
      syncAvailability(card.querySelector('[data-psw="' + String(id).replace(/[^0-9]/g, '') + '"]'));
    });

    // Executa na captura: uma variante sabidamente esgotada nunca chega ao
    // handler AJAX do card nem produz o erro genérico de estoque do Shopify.
    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-variant-available') === 'false') {
        e.preventDefault();
        e.stopImmediatePropagation();
        btn.disabled = true;
        label.textContent = form.getAttribute('data-label-sold-out') || form.getAttribute('data-label-error');
      }
    }, true);

    syncAvailability(card.querySelector('[data-psw].active'));
  });
})();

/* ===== #11: Hero — marca a imagem ativa para o Ken Burns ===== */
(function () {
  'use strict';
  document.querySelectorAll('[data-hero-swatch]').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var hero = sw.closest('.hero');
      var stage = hero ? hero.querySelector('.hero-stage') : null;
      if (!stage) return;
      var id = sw.getAttribute('data-hero-swatch');
      stage.querySelectorAll('img').forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-img') === id);
      });
    });
  });
})();

/* ===== #5: carrinho AJAX — quantidade, remoção, subtotal e badge sem reload =====
 * Fonte única de verdade dos steppers do carrinho (os onclick inline foram removidos).
 * A página /cart é re-renderizada pela Section Rendering API, então preço de linha,
 * subtotal e empty state vêm prontos do servidor (nada de formatar dinheiro no cliente).
 * Expõe window.BuddyLabCart para o drawer (#14) reaproveitar.
 * -------------------------------------------------------------------------------- */
(function () {
  'use strict';

  var body = document.body;
  var changeUrl = (body.getAttribute('data-cart-change-url') || '/cart/change') + '.js';
  var cartUrl = body.getAttribute('data-cart-url') || '/cart';
  var cartJsonUrl = cartUrl.replace(/\.js$/, '') + '.js';
  var timers = {};
  var changeVersion = 0;

  var S = {};
  var stringsEl = document.querySelector('[data-cart-strings]');
  if (stringsEl) { try { S = JSON.parse(stringsEl.textContent); } catch (e) { S = {}; } }

  function fill(template, token, value) {
    return String(template == null ? '' : template).split(token).join(value);
  }

  // Clamp otimista no cliente: o servidor (/cart/change.js) continua sendo a
  // fonte de verdade do estoque, isso só evita a volta redonda quando o `max`
  // do input já denuncia o teto.
  function clampToMax(input, next) {
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && max > 0 && next > max) {
      showChangeError(fill(S.max_stock, '__N__', max));
      return max;
    }
    return next;
  }

  function cartPage() { return document.querySelector('[data-cart-page]'); }

  function announce(msg) {
    document.querySelectorAll('[data-cart-live]').forEach(function (el) {
      var text = msg || el.getAttribute('data-announce') || '';
      el.textContent = '';
      setTimeout(function () { el.textContent = text; }, 60);
    });
  }

  function setBusy(on) {
    document.querySelectorAll('[data-cart-page], [data-cart-drawer]').forEach(function (el) {
      el.classList.toggle('is-cart-busy', !!on);
      el.setAttribute('aria-busy', on ? 'true' : 'false');
    });
  }

  function clearChangeError() {
    document.querySelectorAll('[data-cart-change-error]').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
  }

  function showChangeError(message) {
    if (!message) return;
    document.querySelectorAll('[data-cart-change-error]').forEach(function (el) {
      el.textContent = message;
      el.hidden = false;
    });
  }

  function fallback() {
    window.location.reload();
  }

  function showError(message) {
    document.querySelectorAll('[data-cart-ajax-error]').forEach(function (el) {
      el.textContent = message || '';
      el.hidden = !message;
    });
  }

  function cartJSON() {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-sync-failed');
        return r.json();
      });
  }

  function resync(sectionId) {
    return cartJSON().then(function (cart) {
      document.dispatchEvent(new CustomEvent('buddylab:cart:updated', { detail: cart }));
      if (!sectionId) return cart;
      return fetch(cartUrl + '?section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) return '';
          return r.text();
        })
        .then(function (html) {
          if (html) renderSection(html);
          return cart;
        })
        .catch(function () { return cart; });
    });
  }

  function findRow(scope, key) {
    var rows = scope.querySelectorAll('[data-cart-line]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-line-key') === key) return rows[i];
    }
    return null;
  }

  // Re-render troca o DOM inteiro da section: guarda e devolve o foco do teclado.
  function snapshotFocus() {
    var page = cartPage();
    var el = document.activeElement;
    if (!page || !el || !page.contains(el)) return null;
    var row = el.closest('[data-cart-line]');
    var role = el.hasAttribute('data-qty-dec') ? '[data-qty-dec]'
      : el.hasAttribute('data-qty-inc') ? '[data-qty-inc]'
      : el.hasAttribute('data-qty-input') ? '[data-qty-input]'
      : el.hasAttribute('data-cart-remove') ? '[data-cart-remove]' : null;
    if (!row || !role) return null;
    return { key: row.getAttribute('data-line-key'), role: role };
  }

  function restoreFocus(snap) {
    var page = cartPage();
    if (!snap || !page) return;
    var row = findRow(page, snap.key);
    var el = row && row.querySelector(snap.role);
    if (el) el.focus();
  }

  function renderSection(html) {
    var page = cartPage();
    if (!page || !html) return;
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
    if (!next) return;
    var snap = snapshotFocus();
    page.replaceWith(next);
    restoreFocus(snap);
  }

  // #96: mesmo rótulo acessível de refreshCartBadge, ver comentário lá.
  function cartCountLabel(count) {
    var base = document.body.getAttribute('data-label-cart') || '';
    if (!count) return base;
    var tmpl = document.body.getAttribute(count === 1 ? 'data-label-cart-item-one' : 'data-label-cart-item-other') || '';
    return tmpl ? base + ', ' + tmpl.replace('__N__', count) : base;
  }

  function updateFromCart(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    document.querySelectorAll('[data-cart-count-label]').forEach(function (el) {
      el.textContent = cartCountLabel(cart.item_count);
    });
    document.dispatchEvent(new CustomEvent('buddylab:cart:updated', { detail: cart }));
  }

  // Depois de uma recusa do servidor, o DOM otimista pode estar defasado. Busca a
  // fonte autoritativa sem submeter updates[] posicionais e sem recarregar a página.
  function resync(sectionId, version) {
    var requests = [];

    requests.push(fetch(cartJsonUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-sync-failed');
        return r.json();
      })
      .then(function (cart) {
        if (version === changeVersion) updateFromCart(cart);
      }));

    if (sectionId) {
      var separator = cartUrl.indexOf('?') === -1 ? '?' : '&';
      requests.push(fetch(cartUrl + separator + 'section_id=' + encodeURIComponent(sectionId), {
        headers: { Accept: 'text/html' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart-section-sync-failed');
          return r.text();
        })
        .then(function (html) {
          if (version === changeVersion) renderSection(html);
        }));
    }

    return Promise.all(requests);
  }

  function change(key, quantity) {
    var version = ++changeVersion;
    var page = cartPage();
    var sectionId = page ? page.getAttribute('data-section-id') : null;
    var payload = { id: key, quantity: quantity };
    if (sectionId) { payload.sections = sectionId; payload.sections_url = cartUrl; }

    clearChangeError();
    setBusy(true);
    showError('');
    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json()
          .catch(function () { return {}; })
          .then(function (data) { return { ok: r.ok, data: data }; });
      }, function () {
        if (version === changeVersion) {
          setBusy(false);
          fallback();
        }
        return null;
      })
      .then(function (res) {
        if (!res) return null;
        if (version !== changeVersion) return null;
        if (!res.ok) {
          var message = res.data.description || res.data.message;
          return resync(sectionId, version)
            .catch(function () {})
            .then(function () {
              if (version !== changeVersion) return null;
              showChangeError(message);
              setBusy(false);
              return null;
            });
        }

        var cart = res.data;
        if (sectionId && cart.sections) renderSection(cart.sections[sectionId]);
        updateFromCart(cart);
        announce();
        setBusy(false);
        return cart;
      });
  }

  // Cliques rápidos viram uma única requisição com a quantidade final.
  function queue(key, quantity) {
    if (timers[key]) clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      delete timers[key];
      change(key, quantity);
    }, 400);
  }

  function flush(key) {
    if (timers[key]) { clearTimeout(timers[key]); delete timers[key]; }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var step = e.target.closest('[data-cart-qty] [data-qty-dec], [data-cart-qty] [data-qty-inc]');
    if (step) {
      var box = step.closest('[data-cart-qty]');
      var input = box.querySelector('[data-qty-input]');
      var row = step.closest('[data-cart-line]');
      if (!input || !row) return;
      var current = parseInt(input.value, 10) || 1;
      if (step.hasAttribute('data-qty-dec') && current <= 1) return;
      var raw = Math.max(1, current + (step.hasAttribute('data-qty-inc') ? 1 : -1));
      var next = clampToMax(input, raw);
      input.value = next;
      var dec = box.querySelector('[data-qty-dec]');
      if (dec) dec.disabled = next <= 1;
      queue(row.getAttribute('data-line-key'), next);
      return;
    }

    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      var rmRow = rm.closest('[data-cart-line]');
      if (!rmRow) return;
      e.preventDefault();
      var key = rmRow.getAttribute('data-line-key');
      flush(key);
      change(key, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest ? e.target.closest('[data-qty-input]') : null;
    if (!input) return;
    var row = input.closest('[data-cart-line]');
    if (!row) return;
    var raw = Math.max(1, parseInt(input.value, 10) || 1);
    var value = clampToMax(input, raw);
    input.value = value;
    queue(row.getAttribute('data-line-key'), value);
  });

  window.BuddyLabCart = { change: change, queue: queue, flush: flush, announce: announce, setBusy: setBusy };
})();

/* ===== #14: cart drawer + barra de sacola fixa no mobile =====
 * O drawer é um snippet do layout (não uma section), então não dá pra usar a
 * Section Rendering API: o conteúdo é re-montado no cliente a partir do JSON do
 * carrinho. Ele escuta 'buddylab:cart:updated' (disparado pelo bloco #5 e pelo
 * refreshCartBadge) e 'buddylab:cart:added' para abrir sozinho depois de um add.
 * -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var overlay = document.querySelector('[data-cart-overlay]');
  var mbar = document.querySelector('[data-mcartbar]');
  var cartJsUrl = (document.body.getAttribute('data-cart-url') || '/cart') + '.js';
  var threshold = parseInt(drawer.getAttribute('data-free-threshold'), 10) || 0;

  var S = {};
  var stringsEl = document.querySelector('[data-cart-strings]');
  if (stringsEl) { try { S = JSON.parse(stringsEl.textContent); } catch (e) { S = {}; } }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var lastFocused = null;
  var lockedScrollY = 0;

  // ---- helpers ----
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fill(template, token, value) {
    return String(template == null ? '' : template).split(token).join(value);
  }

  // Porta do formatMoney do Shopify: o /cart.js devolve centavos, não texto.
  function formatMoney(cents) {
    var format = S.money_format || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);

    function withDelimiters(precision, thousands, decimal) {
      if (isNaN(cents) || cents == null) return '0';
      var number = (cents / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = withDelimiters(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(2, "'", '.'); break;
      default: value = withDelimiters(2, ',', '.');
    }
    return format.replace(placeholder, value);
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function countLabel(count) {
    return fill(count === 1 ? S.item_one : S.item_other, '__N__', count);
  }

  var productPromises = {};
  var renderVersion = 0;

  function productFor(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productPromises[handle]) {
      var root = S.root_url || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      productPromises[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('cart-product-pricing-failed');
        return response.json();
      }).catch(function () { return null; });
    }
    return productPromises[handle];
  }

  function enrichPricing(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    return Promise.all(cart.items.map(function (item) {
      return productFor(item.handle).then(function (product) {
        if (!product || !product.variants) return;
        item._buddyVariant = product.variants.find(function (variant) {
          return String(variant.id) === String(item.variant_id);
        }) || null;
      });
    })).then(function () { return cart; });
  }

  // #96: rótulo acessível do link da sacola no header (ver refreshCartBadge em global.js).
  function cartAccessibleLabel(count) {
    var base = document.body.getAttribute('data-label-cart') || '';
    return count > 0 ? base + ', ' + countLabel(count) : base;
  }

  // ---- render ----
  function itemHTML(item) {
    var media = item.image
      ? '<img src="' + esc(sizedImage(item.image, 144)) + '" alt="' + esc(item.product_title) + '" width="72" height="90" loading="eager">'
      : '<div class="cart-item__ph" aria-hidden="true"></div>';

    var optionsText = (item.options_with_values || [])
      .filter(function (opt) { return opt.value && opt.value !== 'Default Title'; })
      .map(function (opt) { return fill(fill(S.option, '__NAME__', opt.name), '__VALUE__', opt.value); })
      .join(' · ');
    if (!optionsText && item.variant_title) optionsText = item.variant_title;
    var meta = (!item.product_has_only_default_variant && optionsText)
      ? '<div class="ci-meta">' + esc(optionsText) + '</div>'
      : '';

    var variant = item._buddyVariant;
    var unitPrice = variant ? variant.price : item.original_price;
    var compareAt = variant && variant.compare_at_price;
    var priceHTML = '<div class="ci-price">' +
      (compareAt > unitPrice
        ? '<s class="cart-line-price__was">' + esc(formatMoney(compareAt * item.quantity)) + '</s>'
        : '') +
      (item.quantity > 1
        ? '<span class="cart-line-price__unit">' +
          esc(fill(S.unit_price, '__PRICE__', formatMoney(unitPrice))) + '</span>'
        : '') +
      '<strong data-line-price>' + esc(formatMoney(item.final_line_price)) + '</strong></div>';

    return '<div class="cart-item" data-cart-line data-line-key="' + esc(item.key) + '">' +
      media +
      '<div>' +
        '<a href="' + esc(item.url) + '" class="ci-name">' + esc(item.product_title) + '</a>' +
        meta +
        '<div class="ci-qty" data-cart-stepper>' +
          '<button type="button" data-qty-dec aria-label="' + esc(S.qty_decrease) + '"' +
            (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
          '<span data-ci-qty>' + esc(item.quantity) + '</span>' +
          '<button type="button" data-qty-inc aria-label="' + esc(S.qty_increase) + '">+</button>' +
        '</div>' +
        '<button type="button" class="ci-remove" data-cart-remove aria-label="' +
          esc(fill(S.remove_item, '__NAME__', item.product_title)) + '">' + esc(S.remove) + '</button>' +
      '</div>' +
      priceHTML +
    '</div>';
  }

  function footHTML(cart) {
    if (!cart.item_count) return '';
    var free = cart.total_price >= threshold;
    var total = esc(formatMoney(cart.total_price));
    var subtotal = esc(formatMoney(cart.items_subtotal_price));

    var html = '<div class="cart-totals"><span>' + esc(S.subtotal) + '</span>' +
      '<span data-cart-drawer-subtotal>' + subtotal + '</span></div>';

    if (cart.total_discount > 0) {
      var titles = (cart.cart_level_discount_applications || []).map(function (discount) {
        return discount.title;
      }).filter(Boolean);
      html += '<div class="cart-totals cart-discount"><span>' + esc(S.discount) +
        (titles.length ? ' · ' + esc(titles.join(', ')) : '') + '</span>' +
        '<span>−' + esc(formatMoney(cart.total_discount)) + '</span></div>';
    }

    html += '<div class="cart-totals"><span>' + esc(S.shipping) + '</span>' +
      (free
        ? '<span class="cart-ship cart-ship--free">' + esc(S.shipping_free) + '</span>'
        : '<span class="cart-ship">' + esc(S.shipping_calculated) + '</span>') +
      '</div>';

    if (!free) {
      var missing = '<b>' + esc(formatMoney(threshold - cart.total_price)) + '</b>';
      html += '<p class="cart-progress">' + fill(S.progress, '__AMOUNT__', missing) + '</p>';
    }

    return html +
      '<div class="cart-totals total"><span>' + esc(S.total) + '</span>' +
      '<span data-cart-drawer-total>' + total + '</span></div>' +
      '<a class="cart-checkout" href="/checkout">' + esc(S.checkout) + '</a>' +
      '<a class="cart-view-link" href="' + esc(S.cart_url || '/cart') + '">' + esc(S.view_full_cart) + '</a>';
  }

  function snapshotDrawerFocus() {
    var el = document.activeElement;
    if (!el || !drawer.contains(el)) return null;
    var row = el.closest('[data-cart-line]');
    if (!row) return null;
    var rows = Array.prototype.slice.call(drawer.querySelectorAll('[data-cart-line]'));
    var role = el.hasAttribute('data-qty-dec') ? '[data-qty-dec]'
      : el.hasAttribute('data-qty-inc') ? '[data-qty-inc]'
      : el.hasAttribute('data-cart-remove') ? '[data-cart-remove]' : null;
    if (!role) return null;
    return { key: row.getAttribute('data-line-key'), role: role, index: rows.indexOf(row) };
  }

  function restoreDrawerFocus(snap) {
    if (!snap || !drawer.classList.contains('open')) return;
    var row = findDrawerRow(snap.key);
    var target = row && row.querySelector(snap.role);
    if (!target) {
      var rows = drawer.querySelectorAll('[data-cart-line]');
      row = rows[Math.min(snap.index, rows.length - 1)];
      target = row && row.querySelector('[data-qty-inc], [data-cart-remove], a[href]');
    }
    if (!target) target = drawer.querySelector('[data-cart-close]');
    if (target) target.focus();
  }

  function findDrawerRow(key) {
    var rows = drawer.querySelectorAll('[data-cart-line]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-line-key') === key) return rows[i];
    }
    return null;
  }

  function render(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var focus = snapshotDrawerFocus();

    var count = drawer.querySelector('[data-cart-drawer-count]');
    if (count) count.textContent = cart.item_count > 0 ? '· ' + countLabel(cart.item_count) : '';

    var bodyEl = drawer.querySelector('[data-cart-drawer-body]');
    if (bodyEl) {
      bodyEl.innerHTML = cart.item_count === 0
        ? '<div class="cart-empty"><div class="editorial">' + esc(S.empty) + '</div><p>' + esc(S.empty_sub) +
          '</p><a href="' + esc(S.products_url) + '" class="btn btn-dark" data-cart-close>' +
          esc(S.view_products) + ' →</a></div>'
        : cart.items.map(itemHTML).join('');
    }

    var footEl = drawer.querySelector('[data-cart-drawer-foot]');
    if (footEl) {
      footEl.innerHTML = footHTML(cart);
      footEl.hidden = cart.item_count === 0;
    }

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    document.querySelectorAll('[data-cart-count-label]').forEach(function (el) {
      el.textContent = cartAccessibleLabel(cart.item_count);
    });

    if (mbar) {
      mbar.classList.toggle('show', cart.item_count > 0);
      var sub = mbar.querySelector('[data-mcartbar-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);
    }
    restoreDrawerFocus(focus);
  }

  function refresh() {
    return fetch(cartJsUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-refresh-failed');
        return r.json();
      })
      .then(function (cart) {
        var version = ++renderVersion;
        return enrichPricing(cart).then(function () {
          if (version === renderVersion) render(cart);
          return cart;
        });
      });
  }

  // ---- abrir / fechar ----
  function visibleFocusable() {
    return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { close(); return; }
    if (e.key !== 'Tab') return;

    var items = visibleFocusable();
    if (!items.length) { e.preventDefault(); drawer.focus(); return; }

    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (drawer.classList.contains('open')) return;
    lastFocused = document.activeElement;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.body.classList.add('cart-lock');
    window.BuddyLabHideBackground(overlay ? [drawer, overlay] : [drawer], true);
    document.addEventListener('keydown', onKeydown);
    var first = visibleFocusable()[0];
    (first || drawer).focus();
  }

  function close() {
    if (!drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('open');
    document.body.classList.remove('cart-lock');
    document.body.style.top = '';
    window.BuddyLabHideBackground(overlay ? [drawer, overlay] : [drawer], false);
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && document.contains(lastFocused)) {
      try { lastFocused.focus({ preventScroll: true }); }
      catch (e) { lastFocused.focus(); }
    }
    lastFocused = null;
    window.scrollTo(0, lockedScrollY);
  }

  // ---- eventos ----
  if (window.BuddyLabEarlyCartOpen) {
    document.removeEventListener('click', window.BuddyLabEarlyCartOpen);
    window.BuddyLabEarlyCartOpen = null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var opener = e.target.closest('[data-cart-open]');
    var link = e.target.closest('a[href]');
    var headerCart = link && link.closest('.header') && link.getAttribute('href') === document.body.getAttribute('data-cart-url');
    if (opener || headerCart) {
      e.preventDefault();
      // #179: o drawer já vem do servidor com o cart atual (cart-drawer.liquid) e é
      // mantido em sincronia via eventos buddylab:cart:*. Abrir só depois do /cart.js
      // resolver fazia o primeiro clique após o load parecer "sem reação" sempre que
      // essa requisição demorava ou falhava (rede ocupada carregando outros recursos).
      open();
      refresh().catch(function () {
        // Só navega no fallback se o drawer não tiver sido aberto por [data-cart-open]:
        // o ícone da sacola já satisfaz headerCart também, e o drawer já está aberto,
        // então navegar aqui só causaria um flash antes do unload da página.
        if (headerCart && !opener) window.location.href = link.href;
      });
      return;
    }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { close(); return; }

    var step = e.target.closest('[data-cart-stepper] [data-qty-dec], [data-cart-stepper] [data-qty-inc]');
    if (!step || !window.BuddyLabCart) return;

    var stepper = step.closest('[data-cart-stepper]');
    var label = stepper.querySelector('[data-ci-qty]');
    var row = step.closest('[data-cart-line]');
    if (!label || !row) return;

    var current = parseInt(label.textContent, 10) || 1;
    if (step.hasAttribute('data-qty-dec') && current <= 1) return;
    var next = Math.max(1, current + (step.hasAttribute('data-qty-inc') ? 1 : -1));
    label.textContent = next;
    var dec = stepper.querySelector('[data-qty-dec]');
    if (dec) dec.disabled = next <= 1;
    window.BuddyLabCart.queue(row.getAttribute('data-line-key'), next);
  });

  if (window.BuddyLabCartOpenPending) {
    window.BuddyLabCartOpenPending = false;
    open();
    refresh().catch(function () {});
  }

  document.addEventListener('buddylab:cart:updated', function (e) {
    var cart = e.detail;
    var version = ++renderVersion;
    enrichPricing(cart).then(function () {
      if (version === renderVersion) render(cart);
    });
  });
  document.addEventListener('buddylab:cart:added', function () {
    refresh().then(function (cart) {
      if (cart) open();
    }).catch(function () {});
  });
})();

/* ---- MOBILE MENU: drawer de navegação (#9) ---- */
(function () {
  'use strict';

  var toggle = document.querySelector('[data-menu-open]');
  var drawer = document.querySelector('[data-menu]');
  var overlay = document.querySelector('[data-menu-overlay]');
  if (!toggle || !drawer || !overlay) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var lastFocused = null;

  function focusable() {
    return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.getClientRects().length > 0;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeMenu();
      return;
    }
    if (e.key !== 'Tab') return;

    var items = focusable();
    if (!items.length) { e.preventDefault(); drawer.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;

    if (e.shiftKey && (active === first || active === drawer)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault(); first.focus();
    } else if (!drawer.contains(active)) {
      e.preventDefault(); first.focus();
    }
  }

  function openMenu() {
    lastFocused = document.activeElement;
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
    window.BuddyLabHideBackground([drawer, overlay], true);
    drawer.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeMenu() {
    if (!drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
    window.BuddyLabHideBackground([drawer, overlay], false);
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
    lastFocused = null;
  }

  toggle.addEventListener('click', function () {
    if (drawer.classList.contains('open')) closeMenu(); else openMenu();
  });
  overlay.addEventListener('click', closeMenu);

  var closeBtn = drawer.querySelector('[data-menu-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  // Navegar dentro da mesma página (âncoras) não recarrega: fecha na mão
  drawer.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  // Voltar ao desktop com o drawer aberto deixaria o body travado
  window.addEventListener('resize', function () {
    if (window.innerWidth > 980) closeMenu();
  });
})();

/* ---- NEWSLETTER: estado do botão durante o envio (#16) ---- */
(function () {
  'use strict';

  document.querySelectorAll('[data-newsletter-submit]').forEach(function (btn) {
    var form = btn.form || btn.closest('form');
    if (!form) return;
    var idle = btn.textContent;
    form.addEventListener('submit', function () {
      if (!form.checkValidity || form.checkValidity()) {
        btn.textContent = btn.getAttribute('data-sending-label') || idle;
        btn.disabled = true;
      }
    });
    // Voltar pelo histórico (bfcache) devolveria um botão travado
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { btn.textContent = idle; btn.disabled = false; }
    });
  });
})();

/* ===== #22: card de produto — compare_at e badge seguem a variante exibida ===== */
/* O bloco de swatch lá em cima já troca imagem, rótulo e preço; aqui completamos
 * o resto da linha de preço (riscado, classe is-sale e badge de desconto) a
 * partir dos data-* que o snippet card-product.liquid escreve por variante.
 * Assim nenhum card mostra um desconto que não seja o da variante na tela. */
(function () {
  'use strict';

  document.querySelectorAll('[data-pcard]').forEach(function (card) {
    var priceEl = card.querySelector('[data-card-price]');
    var compareEl = card.querySelector('[data-card-compare]');
    var badgeEl = card.querySelector('[data-card-sale-badge]');
    if (!priceEl && !compareEl && !badgeEl) return;

    // O bloco de swatch dispara este evento depois de atualizar o preço.
    card.addEventListener('pcard:variant', function (e) {
      var id = e.detail && e.detail.id;
      if (!id) return;
      var sw = card.querySelector('[data-psw="' + String(id).replace(/[^0-9]/g, '') + '"]');
      if (!sw) return;

      var compare = sw.getAttribute('data-compare') || '';
      var badge = sw.getAttribute('data-badge') || '';

      if (priceEl) priceEl.classList.toggle('is-sale', !!compare);
      if (compareEl) {
        compareEl.textContent = compare;
        compareEl.hidden = !compare;
      }
      if (badgeEl) {
        badgeEl.textContent = badge;
        badgeEl.hidden = !badge;
      }
    });

    // A variante exibida é a selected_or_first_available, que nem sempre é a
    // primeira do card (a primeira pode estar esgotada). O mini-carrossel (#12)
    // assume que começou na posição 0, então avisamos onde ele realmente está.
    var swatches = card.querySelectorAll('[data-psw]');
    var active = -1;
    swatches.forEach(function (sw, i) { if (sw.classList.contains('active')) active = i; });
    if (active > 0) {
      card.dispatchEvent(new CustomEvent('pcard:variant', {
        detail: { id: swatches[active].getAttribute('data-psw') }
      }));
    }
  });
})();

/* ===== #15: carrossel do Instagram (arrasto + setas) ===== */
(function () {
  'use strict';

  document.querySelectorAll('[data-ig-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-ig-track]');
    if (!track) return;

    var prev = root.querySelector('[data-ig-prev]');
    var next = root.querySelector('[data-ig-next]');

    function step() {
      var card = track.querySelector('.ig-card');
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 18;
      var width = card ? card.getBoundingClientRect().width : 280;
      return (width + gap) * 1.5;
    }

    function syncArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();

    // Arrasto com mouse/caneta. No toque o scroll nativo já faz o trabalho
    // (duplicar aqui brigaria com o momentum do sistema).
    var dragging = false, startX = 0, startScroll = 0, moved = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('dragging');
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        // A partir daqui é arrasto, não clique: segura o pointer pra não
        // perder o movimento ao sair do track.
        if (track.setPointerCapture) {
          try { track.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
        }
      }
      if (!moved) return;
      e.preventDefault();
      track.scrollLeft = startScroll - dx;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('dragging');
      syncArrows();
      // Deixa o clique morrer antes de reabilitar os links
      if (moved) setTimeout(function () { moved = false; }, 0);
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    window.addEventListener('blur', endDrag);

    // Um arrasto que termina em cima de um card não deve abrir o link
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    track.addEventListener('dragstart', function (e) { if (dragging) e.preventDefault(); });
  });
})();

/* ---- HEADER: submenus desktop e mobile (#47) ---- */
(function () {
  'use strict';

  function setDesktopState(item, open) {
    var button = item.querySelector('[data-desktop-submenu-toggle]');
    item.classList.toggle('is-open', open);
    item.classList.toggle('is-closed', !open);
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.querySelectorAll('[data-desktop-submenu]').forEach(function (item) {
    var button = item.querySelector('[data-desktop-submenu-toggle]');
    if (!button) return;

    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') !== 'true';
      document.querySelectorAll('[data-desktop-submenu]').forEach(function (other) {
        setDesktopState(other, other === item && open);
      });
    });
    item.addEventListener('focusin', function () { setDesktopState(item, true); });
    item.addEventListener('mouseenter', function () { setDesktopState(item, true); });
    item.addEventListener('mouseleave', function () {
      if (!item.contains(document.activeElement)) setDesktopState(item, false);
    });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) setDesktopState(item, false);
    });
    item.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      event.preventDefault();
      button.focus();
      setDesktopState(item, false);
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-desktop-submenu]')) return;
    document.querySelectorAll('[data-desktop-submenu]').forEach(function (item) {
      setDesktopState(item, false);
    });
  });

  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      var open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    });
  });
})();

/* ===== #74: acessibilidade dos controles do catálogo ===== */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-filter-drawer]');

  document.querySelectorAll('.fopt[role="checkbox"]').forEach(function (filter) {
    filter.addEventListener('keydown', function (event) {
      if (event.key !== ' ') return;
      event.preventDefault();
      filter.click();
    });
  });

  document.querySelectorAll('[data-density]').forEach(function (button) {
    button.setAttribute('aria-pressed', button.classList.contains('active') ? 'true' : 'false');
    button.addEventListener('click', function () {
      document.querySelectorAll('[data-density]').forEach(function (other) {
        other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
      });
    });
  });

  document.querySelectorAll('[data-psw]').forEach(function (swatch) {
    swatch.setAttribute('aria-pressed', swatch.classList.contains('active') ? 'true' : 'false');
    swatch.addEventListener('click', function () {
      var card = swatch.closest('[data-pcard]');
      if (!card) return;
      card.querySelectorAll('[data-psw]').forEach(function (other) {
        other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
      });
    });
  });

  if (!drawer) return;
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || !drawer.classList.contains('open')) return;
    var items = drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!items.length) {
      event.preventDefault();
      drawer.focus();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();

/* ---- PDP: acordeão — painel fechado sai do foco e do leitor de tela (#68) ---- */
/* O handler original (bloco da PDP acima) só alterna a classe .open e o
   aria-expanded; `max-height: 0` esconde visualmente mas mantém o conteúdo
   focável por Tab e legível pelo leitor de tela. Este bloco registra um
   listener DEPOIS do original, então lê o estado já alternado e sincroniza
   `inert` + `aria-hidden` com ele — preservando a animação de max-height. */
(function () {
  'use strict';

  var supportsInert = 'inert' in HTMLElement.prototype;
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex], [contenteditable="true"]';

  function panelOf(item) {
    var head = item.querySelector('[data-acc-head]');
    var id = head && head.getAttribute('aria-controls');
    return (id && document.getElementById(id)) || item.querySelector('.acc-body');
  }

  // Fallback para navegadores sem `inert`: guarda o tabindex original e o devolve ao abrir.
  function toggleTabStops(panel, open) {
    panel.querySelectorAll(FOCUSABLE).forEach(function (el) {
      if (open) {
        if (!el.hasAttribute('data-acc-tabindex')) return;
        var prev = el.getAttribute('data-acc-tabindex');
        if (prev) el.setAttribute('tabindex', prev); else el.removeAttribute('tabindex');
        el.removeAttribute('data-acc-tabindex');
      } else {
        if (el.hasAttribute('data-acc-tabindex')) return;
        el.setAttribute('data-acc-tabindex', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  function sync(item) {
    var panel = panelOf(item);
    if (!panel) return;
    var open = item.classList.contains('open');

    // Fechando com o foco dentro: devolve o foco ao cabeçalho antes de inertizar.
    if (!open && panel.contains(document.activeElement)) {
      var head = item.querySelector('[data-acc-head]');
      if (head) head.focus();
    }

    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (supportsInert) panel.inert = !open;
    else toggleTabStops(panel, open);
  }

  document.querySelectorAll('[data-acc] [data-acc-item]').forEach(function (item) {
    sync(item);
    var head = item.querySelector('[data-acc-head]');
    if (head) head.addEventListener('click', function () { sync(item); });
  });
})();

/* ---- PDP: preço do botão após o clamp e formulário travado durante o AJAX (#73) ---- */
(function () {
  'use strict';

  /* 1. `update()` chama updatePriceTag() ANTES de reduzir a quantidade ao
     estoque da nova variante, e mudar input.value por script não dispara
     `change`. Resultado: o "· R$ X" do botão multiplica pela quantidade
     antiga. Como `pdp:variantchange` é disparado no fim de update() (já com
     a quantidade clampada), reemitir `pdp:qtychange` daqui recalcula o
     rótulo com o valor que será realmente cobrado. */
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var qtyBox = root.querySelector('[data-qty]:not([data-cart-qty])');
    var qtyInput = qtyBox && qtyBox.querySelector('input');
    if (!qtyInput) return;

    root.addEventListener('pdp:variantchange', function () {
      var min = parseInt(qtyInput.getAttribute('min'), 10);
      var max = parseInt(qtyInput.getAttribute('max'), 10);
      var value = parseInt(qtyInput.value, 10);
      if (isNaN(min) || min < 1) min = 1;
      if (isNaN(value) || value < min) value = min;
      if (!isNaN(max) && max > 0 && value > max) value = max;
      qtyInput.value = value;
      qtyBox.dispatchEvent(new CustomEvent('pdp:qtychange', { bubbles: true }));
    });
  });

  /* 2. O handler de add-to-cart trava só o [data-add-btn] durante o fetch.
     "Comprar agora" é um segundo button[type=submit] no mesmo form, com
     data-skip-ajax: em conexão lenta dá pra clicar nele com o AJAX em voo e
     submeter o form nativamente, dobrando o item. Espelhar o estado
     `disabled` do botão principal cobre tanto o envio em andamento quanto a
     variante indisponível (update() já mantém os dois em sincronia). */
  if (typeof MutationObserver !== 'function') return;

  document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
    var addBtn = form.querySelector('[data-add-btn]');
    if (!addBtn) return;
    var others = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'))
      .filter(function (btn) { return btn !== addBtn; });
    if (!others.length) return;

    new MutationObserver(function () {
      others.forEach(function (btn) { btn.disabled = addBtn.disabled; });
    }).observe(addBtn, { attributes: true, attributeFilter: ['disabled'] });
  });
})();
